export { default as CompanyListingPage } from './company-listing-page';
export { default as ContentPage } from './content-page.jsx';
export { default as CompanyPage } from './company-page.jsx';
export { default as EventListingPage } from './event-listing-page.jsx';
export { default as EventPage } from './event-page.jsx';
export { default as FundPage } from './fund-page.jsx';
export { default as Home } from './home-page.jsx';
export { default as NewsListingPage} from './news-listing-page.jsx';
export { default as NewsPage} from './news-page.jsx';
export { default as PeopleListingPage} from './people-listing-page.jsx';
export { default as PersonPage } from './person-page.jsx';
export { default as AffiliatedOrganisationsListingPage } from './affiliates-listing-page.jsx';

